/**
 * Lab-oriented default .env support
 */
export var environmentMapConfiguration = {
    lab: {
        assetsRootURL: '/assets/environment/',
        environmentMap: {
            texture: 'EnvMap_3.0-256.env',
            rotationY: 0,
            tintLevel: 0.4
        }
    }
};
//# sourceMappingURL=environmentMap.js.map